import { ROLES } from "./roles";

// ──────────────────────────────────────────────
// IDs centralizados — NUNCA hardcodear IDs en componentes
// ──────────────────────────────────────────────

// Priscilla Munguia (gerencia PER) — id individual, reusado donde haga falta identificarla
// puntualmente (ver también EDIFICIOS_ASIGNAR_IDS/CLIENTES_ASIGNAR_IDS más abajo, que ya la
// incluyen como parte de un universo más amplio).
export const PRISCILLA_ID = 7;

// Socios / dueños de la plataforma
export const ADMIN_IDS = [1, 4];

// Acceso al menú de Conciliación SII (/admin/conciliacion-sii). Puerta SEPARADA de ADMIN_IDS a
// propósito (precedente EDITORES_PIN/EDIFICIOS_ADMIN_IDS): puede divergir sin tocar a los dueños.
// Arranca SOLO Ignacio Chile (id 1) — NO reusa ADMIN_IDS ([1, 4]) porque la pantalla es Chile-only
// (facturas_sii_emitidas/recibidas + ingest sii-sync son 100% Chile) y el Ignacio de Perú (id 4)
// no tendría data. Ampliable después sin ensanchar ADMIN_IDS.
export const CONCILIACION_SII_IDS = [1];

// Roles que pueden acceder a la RUTA /admin/conciliacion-sii (gate de la ruta, en App.js vía
// PrivateRoute allowedRoles) — distinto de CONCILIACION_SII_IDS (gate del MENÚ, más estricto:
// solo Ignacio Chile). Sin este gate, la pantalla queda sin entrada de menú pero sigue
// alcanzable por URL directa con cualquier rol de los de abajo — se SACA ADMINISTRATIVO
// (2026-09-12, rehecho 2026-10-05): el único administrativo (Franco) no tiene necesidad
// legítima, sus tareas SII viven en Facturación (SeleccionarDTEModal / ComprasTab→
// AsignarRecibidaModal). CONTABLE se mantiene (uso plausible de conciliación/import por
// período). FUENTE ÚNICA (10.1) consumida por la ruta Y por los puntos de entrada (cards del
// Dashboard Financiero, link de ER v1) para que acceso y links no diverjan.
export const CONCILIACION_SII_ROLES = [ROLES.SUPERADMIN, ROLES.GERENCIA, ROLES.CONTABLE];
export const puedeAccederConciliacionSII = (rol) => CONCILIACION_SII_ROLES.includes(rol);

// Acceso a la vista ER v2 (/admin/er-v2). Puerta dedicada por-función (precedente
// EDIFICIOS_ADMIN_IDS/EDITORES_PIN): amplía el acceso sin ensanchar ADMIN_IDS.
// Ignacio (Chile=1, Perú=4) + Franco Díaz (id 9, administrativo CHI).
export const ER_V2_IDS = [1, 4, 9];

// Universo ÚNICO de roles que ven el ER (v1, y en Chile v2 por FASE 1, 2026-09-05).
// Fuente única consumida por App.js: la ruta /admin/er (allowedRoles) y el gate de país
// de /admin/er-v2 (alsoAllow) leen de acá para garantizar "mismo universo" sin divergir.
export const ER_ROLES = [
  ROLES.SUPERADMIN,
  ROLES.GERENCIA,
  ROLES.BOARD,
  ROLES.CONTABLE,
  ROLES.ADMINISTRATIVO,
  ROLES.INVERSOR,
];

// Gerencia / dueños — Ignacio (Chile 1 / Perú 4). Puerta dedicada por-función (precedente
// EDITORES_PIN/FORZAR_VINCULACION_IDS): puede divergir de ADMIN_IDS sin tocar a los dueños.
// Gatea la edición de la fecha de pago del sueldo líquido en el flujo (FASE 8.2).
export const GERENTE_IDS = [1, 4];

// Universo que VE el Radar Comercial (botón + contador + panel del Home, `AlertasRecurrenciaBanner`).
// Puerta única — el componente la usa ANTES de llamar `cargarDatosAlertasRecurrencia` (no solo en
// el render), así ningún otro rol dispara la query. Agencia, cliente y administrativo quedan fuera
// a propósito (2026-09-26).
export const ROLES_VEN_RADAR = [ROLES.SUPERADMIN, ROLES.GERENCIA, ROLES.COMERCIAL, ROLES.BOARD, ROLES.INVERSOR];

// Inversores con acceso restringido (solo lectura parcial).
// Vacío: 1623/1624 pasaron a rol broker (su denylist los bloqueaba de ventas-detalle/proyección,
// sus vistas principales). Los inversores reales (1525, 1572) nunca estuvieron acá.
// La constante se mantiene porque App.js y menuConfig.js la importan como deniedIds.
export const INVERSORES_RESTRINGIDOS = [];

// Usuarios que ven todas las ventas en reporte fotográfico
export const USERS_ALL_VENTAS = [1, 4, 7, 306, 904];

// Usuarios con acceso a galería como admin (pueden subir/borrar)
export const GALERIA_ADMIN_IDS = [1, 4, 306, 904];

// Permiso por-función: editar ubicación de pines en /mapa.
// Hoy coincide con ADMIN_IDS pero es independiente y puede divergir.
export const EDITORES_PIN = [1, 4];

// Crear/editar edificios y comisiones (puerta única, Bloque C) — exclusivo Ignacio
// (Chile=1, Perú=4) hasta dominar el subsistema; ampliable después. Constante dedicada
// por-función (sigue el precedente de EDITORES_PIN): puede divergir sin tocar a los dueños.
export const EDIFICIOS_ADMIN_IDS = [1, 4];

// Eliminar (soft-delete, eliminada=true) un edificio desde el kebab. Puerta SEPARADA de
// EDIFICIOS_ADMIN_IDS a propósito: eliminar es más destructivo que crear/editar, así que
// arranca más restringido y puede divergir sin tocar el CRUD. IDs REALES de Ignacio —
// id 1 = Ignacio Mailhos (gerencia CHI, ignacio@wecast.cl), id 4 = Ignacio Mailhos
// (gerencia PER, ignacio.mailhos@visiona.pe), verificados contra la tabla usuarios; NO es
// el placeholder de la regla 10.104. Restricción SOLO de UI y temporal: el candado real
// debe vivir en la RLS de la DB y el gate debe pasar a un flag/rol (ver ROADMAP_TECNICO).
export const ELIMINAR_EDIFICIO_IDS = [1, 4];

// Forzar la vinculación de un movimiento bancario que pagó MENOS que la Σ de facturas
// (faltante): cierra las facturas al 100% con un ajuste interno, deja marca "forzado/
// pendiente" y registra auditoría en vinculaciones_forzadas. Decisión de gerencia —
// exclusivo Ignacio (Chile=1, Perú=4). Puerta dedicada por-función (precedente
// EDIFICIOS_ADMIN_IDS/EDITORES_PIN): puede divergir sin tocar a los dueños.
export const FORZAR_VINCULACION_IDS = [1, 4];

// Asignar/editar los edificios de un usuario rol='edificio' (columna edificiosOk en
// /admin/usuarios). Puerta SEPARADA de EDIFICIOS_ADMIN_IDS a propósito: esto no es CRUD
// de edificios ni comisiones, solo cablear qué edificios ve una cuenta de rol edificio.
// Ignacio (CHI=1, PER=4) + staff que opera edificios: Franco Díaz (id 9, administrativo CHI)
// y Priscilla Munguia (id 7, gerencia PER).
export const EDIFICIOS_ASIGNAR_IDS = [1, 4, 9, 7];

// Vincular clientes a un contacto rol='agencia' (tabla puente usuarios_clientes, modal
// "Clientes vinculados" en /admin/usuarios). Puerta SEPARADA por-función, calcada de
// EDIFICIOS_ASIGNAR_IDS: cablear qué clientes ve un contacto de agencia en el reporte
// fotográfico, no es CRUD de clientes. Staff operativo:
//   1 Ignacio Mailhos (gerencia CHI) · 4 Ignacio Mailhos (gerencia PER)
//   7 Priscilla Munguia (gerencia PER) · 9 Franco Díaz (administrativo CHI)
//   904 Nicolás "Nico" Soto (agencia CHI) · 306 Karin Ulffe (comercial PER)
export const CLIENTES_ASIGNAR_IDS = [1, 4, 7, 9, 904, 306];

// Cargar/reemplazar la liquidación de sueldo LEGAL (PDF de la contadora) de CUALQUIER empleado, en
// /admin/gestion-empleados → kebab → "Liquidaciones". Puerta dedicada por-función (precedente
// EDIFICIOS_ADMIN_IDS/EDITORES_PIN): Ignacio (Chile=1, Perú=4) + Franco Díaz (id 9, administrativo
// CHI) — universo confirmado por Ignacio en el diseño de la tabla `liquidaciones_contadora`
// (docs/decisiones/2026-09-28-liquidaciones-contadora-fase-a-db.md §7.1). La base YA fuerza este
// mismo universo vía `es_admin_liquidaciones()` (RLS + la RPC `guardar_liquidacion_contadora`) — esta
// constante debe mantenerse sincronizada A MANO con el `ARRAY[1,4,9]` de esa función SQL (la base no
// puede importar JS). Un empleado que NO está acá ve solo su propia fila/liquidaciones (10.279).
export const LIQUIDACIONES_ADMIN_IDS = [1, 4, 9];

// Carga de líneas de inversión (modal "Inversión" del edificio, CapEx planificado).
// Lista dedicada por-función: amplía el alcance más allá de puedeEditarTodo
// (superadmin/gerencia) sin tocar el rol del usuario ni EDIFICIOS_ADMIN_IDS.
// Franco Díaz (id 9, rol administrativo) habilitado para cargar inversión.
export const INVERSION_CARGA_IDS = [9];

// Usuarios que pueden cambiar demo en admin
export const DEMO_SWITCH_IDS = [306, 904];

// Usuarios con acceso a la sección Región
export const REGION_IDS = [1, 4, 7, 306, 749, 750, 751, 752];

// Usuarios con acceso a mailing
export const MAILING_IDS = [1, 4];

// Ejecutivos sin comisión (Chile, 2025+)
export const SIN_COMISION_2025 = [1, 4, 904];

// Agencias de venta directa (0% comisión intermediario)
export const AGENCIAS_DIRECTAS = [16, 32, 60];

// Fecha de activación de la comisión de broker (2ª capa de intermediación).
// Constante dura del gate: ninguna venta anterior a esta fecha lleva broker,
// con independencia de lo que diga el registro del intermediario (gate redundante).
export const BROKER_ACTIVACION = "2026-06-01";

// Agencia AdLab Perú: sus brokers (rol "broker", agencia 115) pueden aplicar
// descuento manual en el cotizador con un tope real combinado (ver más abajo).
export const AGENCIA_ADLAB_PERU = 115;

// Tope DURO del descuento real combinado (automático + manual) sobre la tarifa de
// lista para el broker AdLab Perú. Como el manual se aplica sobre la base ya neta de
// descuentoGlobal, la composición es multiplicativa (ver maxManualFracBroker).
export const BROKER_ADLAB_DESCUENTO_MAX = 0.15;

// Equipo OMNET (negociación especial)
export const OMNET_IDS = [1295, 1296, 1297];

// Edificios excluidos de inventario operativo
export const EDIFICIOS_EXCLUIDOS = [119, 121, 157, 158, 159, 168];

// ──────────────────────────────────────────────
// Helpers
// ──────────────────────────────────────────────
export const isAdmin = (id) => ADMIN_IDS.includes(Number(id));

// ¿Este usuario puede VER el ER v2 (/admin/er-v2)? Fuente ÚNICA del acceso: la usan tanto la
// parte aditiva de la ruta (alsoAllow en App.js) como el gate interno del componente
// (ERv2/index.js), para que no puedan volver a divergir. Cubre las dos vías:
//   (a) gate primario por-id — SUPERADMIN/GERENCIA/ADMINISTRATIVO ∧ id ∈ ER_V2_IDS (Perú y resto);
//   (b) FASE 1 — en Chile, el mismo universo que ve el ER v1 (ER_ROLES), respetando
//       INVERSORES_RESTRINGIDOS.
export const puedeVerERv2 = ({ rol, id, pais }) => {
  const nid = Number(id);
  const porId = [ROLES.SUPERADMIN, ROLES.GERENCIA, ROLES.ADMINISTRATIVO].includes(rol) && ER_V2_IDS.includes(nid);
  const porPaisChile = pais === "Chile" && ER_ROLES.includes(rol) && !INVERSORES_RESTRINGIDOS.includes(nid);
  return porId || porPaisChile;
};
export const esGerente = (id) => GERENTE_IDS.includes(Number(id));
export const isInversorRestringido = (id) => INVERSORES_RESTRINGIDOS.includes(Number(id));
export const isEdificiosAdmin = (id) => EDIFICIOS_ADMIN_IDS.includes(Number(id));
export const puedeEliminarEdificio = (id) => ELIMINAR_EDIFICIO_IDS.includes(Number(id));
export const puedeForzarVinculacion = (id) => FORZAR_VINCULACION_IDS.includes(Number(id));
export const puedeAsignarEdificios = (id) => EDIFICIOS_ASIGNAR_IDS.includes(Number(id));
export const puedeAsignarClientes = (id) => CLIENTES_ASIGNAR_IDS.includes(Number(id));
export const puedeCargarInversion = (id) => INVERSION_CARGA_IDS.includes(Number(id));
export const puedeCargarLiquidaciones = (id) => LIQUIDACIONES_ADMIN_IDS.includes(Number(id));

// ¿Este usuario puede ACTUAR sobre el Radar Comercial (sobres C/A + Postergar), no solo verlo?
// Comercial siempre; gerencia solo si su id está en GERENTE_IDS (1 Chile, 4 Perú) — board,
// inversor y el resto de gerencia quedan en modo solo-lectura (columna de acciones muestra el
// estado en texto). Ver ROLES_VEN_RADAR para el universo que ve el Radar.
export const puedeActuarRadar = (rol, id) =>
  rol === ROLES.COMERCIAL || (rol === ROLES.GERENCIA && GERENTE_IDS.includes(Number(id)));

// Broker AdLab Perú habilitado para descuento manual en el cotizador.
// agencia viene como string en DB → comparar por Number.
export const brokerPuedeDescontar = (rol, agencia) => rol === "broker" && Number(agencia) === AGENCIA_ADLAB_PERU;

// ¿Este usuario puede CARGAR/REEMPLAZAR una Orden de Medio (OM) para esta venta/cuota? Espejo
// EXACTO de `puede_cargar_vinculo_orden_medio` (supabase/migrations/20261004g_ordenes_medio.sql,
// 3ª ronda) — permiso PROPIO de OM, deliberadamente SEPARADO de `puedeEditarOportunidad`
// (VentasDetalle/index.js), que no incluye administrativo. `broker` solo si el cliente de ESA
// venta/cuota es de su propia cartera (mismo criterio que `es_broker_dueno_de_cliente` en la base).
export const puedeCargarOrdenMedio = ({ id, rol, agencia, clienteBrokerId }) => {
  if (ADMIN_IDS.includes(Number(id))) return true;
  if (![ROLES.GERENCIA, ROLES.COMERCIAL, ROLES.ADMINISTRATIVO, ROLES.BROKER].includes(rol)) return false;
  if (rol !== ROLES.BROKER) return true;
  return clienteBrokerId === parseInt(agencia, 10);
};

// ¿Este usuario puede VER una Orden de Medio (OM) de esta venta/cuota? Espejo EXACTO de
// `puede_ver_orden_medio` en la base — lista blanca separada de `puedeCargarOrdenMedio` a propósito
// (igual que la base, que las mantiene en 2 funciones distintas aunque hoy el universo de roles
// coincida: VER y CARGAR pueden divergir después sin tocar código de ningún lado). `broker` solo ve
// la de su propia cartera, mismo criterio que al cargar.
export const puedeVerOrdenMedio = ({ id, rol, agencia, clienteBrokerId }) => {
  if (ADMIN_IDS.includes(Number(id))) return true;
  if (![ROLES.GERENCIA, ROLES.COMERCIAL, ROLES.ADMINISTRATIVO, ROLES.BROKER].includes(rol)) return false;
  if (rol !== ROLES.BROKER) return true;
  return clienteBrokerId === parseInt(agencia, 10);
};

// Fracción máxima de descuento manual (sobre baseInversionFinalTotal, ya neta de
// descuentoGlobal) para que el descuento real combinado no supere BROKER_ADLAB_DESCUENTO_MAX.
// descuentoRealTotal = 1 − (1 − descuentoGlobal)(1 − manualFrac) ≤ MAX
//   ⇒ manualFrac ≤ 1 − (1 − MAX) / (1 − descuentoGlobal).
// Si descuentoGlobal ≥ MAX el resultado es ≤ 0 → el broker no puede sumar nada.
export const maxManualFracBroker = (descuentoGlobal) => {
  const g = Number(descuentoGlobal) || 0;
  if (g >= 1) return 0;
  return Math.max(0, 1 - (1 - BROKER_ADLAB_DESCUENTO_MAX) / (1 - g));
};
